import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createSessionStoragePersist } from "../utils/sessionStoragePersist";

export interface FormData {
  name: string;
  birthDate: string;
  birthTime: string;
  birthTimeUnknown: boolean;
  placeOfBirth: string;
  cityNameForApi?: string;
  gender: string;
  timezone?: string;
  latitude?: number;
  longitude?: number;
  countryCode?: string;
}

const initialFormData: FormData = {
  name: "",
  birthDate: "",
  birthTime: "",
  birthTimeUnknown: false,
  placeOfBirth: "",
  cityNameForApi: "",
  gender: "",
  timezone: "",
  latitude: undefined,
  longitude: undefined,
  countryCode: "",
};

interface FormStore {
  formData: FormData;
  step: number;
  setStep: (step: number) => void;
  setFormData: (data: Partial<FormData>) => void;
  resetFormData: () => void;
}

export const useFormDataStore = create<FormStore>()(
  persist(
    (set) => ({
      formData: initialFormData,
      step: 0,
      setStep: (step) => set(() => ({ step })),
      setFormData: (data) =>
        set((state) => ({
          formData: { ...state.formData, ...data },
        })),
      resetFormData: () =>
        set(() => ({
          formData: initialFormData,
          step: 0,
        })),
    }),
    createSessionStoragePersist<FormStore>("form-data")
  )
);
